<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  courseComputed,
  courseListMethod,
  authComputed,
  collegeComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Course List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      courselist: {},
      allCourseList: {},
      collegelist: [],
      allCollegeList: [],
      collegeId: 'All',
      platformId: 'All',
      isUserAdmin: false,
      siteconfiglist: [],
      fields: [
        {
          value: 'name',
          text: 'Name',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'category.name',
          text: 'Category',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'subcategory.name',
          text: 'Sub Category',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'detailAction',
          text: 'Session',
          sortable: false,
          colType: 'detailAction',
        },
        { value: 'rating', text: 'Rating', sortable: true, colType: 'default' },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'name', label: 'Name', colType: 'default' },
        { key: 'features', label: 'Features', colType: 'list' },
        { key: 'topics', label: 'Topics', colType: 'list' },
        { key: 'description', label: 'Description', colType: 'html' },
        { key: 'overview', label: 'Overview', colType: 'html' },
        {
          key: 'career_opportunity',
          label: 'Career Opportunity',
          colType: 'html',
        },
        { key: 'career_salary', label: 'Career Salary', colType: 'html' },
        { key: 'rating', label: 'Rating', colType: 'default' },
        { key: 'duration', label: 'Duration', colType: 'default' },
        { key: 'createdAt', label: 'Published On ', colType: 'date' },
      ],
    }
  },
  computed: {
    ...courseComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getListOfCourses()
    this.getColleges()
  },
  methods: {
    ...courseListMethod,
    ...collegeListMethod,
    ...siteListMethod,

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    getCourses() {
      if (this.collegeId !== 'All') {
        let listitems = []
        this.allCourseList.docs.forEach((element) => {
          if (element.college_id === this.collegeId) {
            listitems.push(element)
          }
        })
        this.courselist.docs = listitems
      } else {
        if (this.role !== 'admin') {
          this.courselist.docs = this.allCourseList.docs
        } else {
          let listitems = []
          this.allCourseList.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              listitems.push(element)
            }
          })
          this.courselist.docs = listitems
        }
      }
    },

    getPlatformColleges() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allCourseList.docs.forEach((element) => {
          if (element.platform_id.includes(Number(this.platformId))) {
            listitems.push(element)
          }
        })
        this.courselist.docs = listitems
      } else {
        this.courselist.docs = this.allCourseList.docs
      }
    },

    // Get list of all courses role wise
    getListOfCourses() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCourseList({ filter })
        .then((courseList) => {
          this.courselist = JSON.parse(JSON.stringify(courseList))
          this.allCourseList = JSON.parse(JSON.stringify(courseList))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
    handleRoute() {
      this.$router.push({ name: 'course.add' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <button
              v-if="role !== 'hod' && role !== 'teacher'"
              id="show-modal"
              class="btn btn-info"
              @click="handleRoute"
              ><i class="ti-plus"></i>Add Course</button
            >
            <br /><br />
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformColleges"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              v-if="
                (role === 'admin' && isUserAdmin) || role === 'administrator'
              "
              label="Select College"
              label-for="input-1"
            >
              <b-form-select
                v-model="collegeId"
                :options="collegelist"
                style="width: 50%"
                @change="getCourses"
              ></b-form-select>
            </b-form-group>
            <Table
              :items="courselist ? courselist.docs : []"
              :table-name="'course'"
              :fields="fields"
              :bordered="true"
              :viewbtn="false"
              :deletebtn="true"
              :editbtn="true"
              :editcourse="true"
              :showdetail="true"
              :display-fields="displayFields"
            ></Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
